<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main max-w" id="page-content-main">
    <div class="" style="padding-bottom:1vh;">
      <!-- <epay-lib-employer-creditcard
        [baseurl]="baseurl"
        [termsContent]="termsContent"
        [creditCardVendorId]="creditCardVendorId"
        [creditCardDisclaimer]="creditCardDisclaimer"
        [validateCaseNumber]="validateCaseNumber"
        [allowZeroAmount]="allowZeroAmount"
        [clientName]="clientName"
        >
      </epay-lib-employer-creditcard> -->

      <emp-cc-payment-common
        [baseurl]="baseurl"
        [termsContent]="termsContent"
        [creditCardVendorId]="creditCardVendorId"
        [creditCardDisclaimer]="creditCardDisclaimer"
        [validateCaseNumber]="validateCaseNumber"
        [allowZeroAmount]="allowZeroAmount"
        [clientName]="clientName">
      </emp-cc-payment-common>

    </div>
  </div>
</epay-page-content>
